import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconThunderRain({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.24226 24.8276C7.99762 25.5017 8.33301 25.9403 8.87424 26.1376C9.41546 26.3349 9.95537 26.2145 10.202 25.5398C10.4466 24.867 10.0764 22.8363 10.0764 22.8363C10.0764 22.8363 8.4869 24.1535 8.24226 24.8276Z"
        fill="white"
      />
      <path
        d="M13.9564 24.8276C13.7098 25.5017 14.0472 25.9403 14.5884 26.1376C15.1296 26.3349 15.6696 26.2145 15.9162 25.5398C16.1608 24.867 15.7906 22.8363 15.7906 22.8363C15.7906 22.8363 14.2011 24.1535 13.9564 24.8276Z"
        fill="white"
      />
      <path
        d="M19.6712 24.8276C19.4246 25.5017 19.7619 25.9403 20.3031 26.1376C20.8444 26.3349 21.3843 26.2145 21.6309 25.5398C21.8755 24.867 21.5053 22.8363 21.5053 22.8363C21.5053 22.8363 19.9158 24.1535 19.6712 24.8276Z"
        fill="white"
      />
      <path
        d="M22.4746 10.4401C22.4227 10.4401 22.3727 10.4473 22.3221 10.4473C21.744 8.01211 19.5633 6.19971 16.9506 6.19971C14.207 6.19971 11.9375 8.2015 11.5061 10.8235C11.1635 10.7268 10.8051 10.6735 10.4309 10.6735C8.53103 10.6735 6.9455 12 6.53909 13.7769C5.05351 14.3595 4 15.8023 4 17.4937C4 19.7007 5.78808 21.4901 7.99573 21.4901H22.4746C25.5267 21.4901 28 19.0181 28 15.9661C28 12.9141 25.526 10.4407 22.4746 10.4407V10.4401ZM15.3039 19.2838L16.6678 14.7712H14.4155L15.7794 9.8574H18.2685L17.2011 13.0193H19.9888L15.3032 19.2845L15.3039 19.2838Z"
        fill="white"
      />
    </svg>
  );
}
